export default function getSubscribeFormData() {
  return {
    pages: [
      {
        elements: [
          {
            type: 'illustration',
            label: 'logo-mutiny-raccoon',
          },
          {
            type: 'title',
            label: 'Get a new conversion secret in your inbox each week',
          },
          {
            type: 'email',
            label: 'Your email',
            validation: 'email',
            required: true,
          },
          {
            type: 'button',
            label: 'Subscribe',
            modifier: 'Button--electricPurpleFill',
            action: 'next',
            subscribe: true,
          },
        ],
      },
      {
        elements: [
          {
            type: 'illustration',
            label: 'logo-mutiny-raccoon',
          },
          {
            type: 'title',
            label: 'You’re in!',
          },
          {
            type: 'subtitle',
            label: 'Look out for an email from us with a new conversion secret each week.',
          },
        ],
      },
    ],
  };
}
